import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Team from "@/pages/Team";

export const Route = createFileRoute("/zh-cn/about-qbd/team")({
  head: () => buildRouteHead("/zh-cn/about-qbd/team"),
  component: Team,
});

